module.exports = __webpack_public_path__ + "media/images/icon_menu-3f86dafeea2c324b09ca5982c2e3d8a1.svg";